import React, { useEffect, useCallback, useState, memo } from 'react';
import { useSidebar } from '../../contexts/SidebarContext';
import MainLayout from '../layout/MainLayout';
import ContentArea from '../layout/ContentArea';
import Sidebar from '../layout/Sidebar';
import PillButton from '../common/button/PillButton';
import UnderlineTabMenu from '../common/menu/UnderlineTabMenu';
import Modal from '../common/Modal';
import CreateAgentForm from './CreateAgentForm';
import AgentsList from './AgentsList';

import styles from './styles/AgentsContainer.module.css';

const AgentsContainer = () => {
    const { setPage: setSidebarPage } = useSidebar();
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [activeTab, setActiveTab] = useState('owned');

    useEffect(() => {
        document.title = 'JetChats - Agents';
        setSidebarPage('agents');
    }, [setSidebarPage]);

    const handleCreateAgent = useCallback(() => {
        setIsCreateModalOpen(true);
    }, []);

    const handleCloseCreateModal = useCallback(() => {
        // Just close the modal; do NOT refresh here.
        setIsCreateModalOpen(false);
    }, []);

    const handleAgentCreated = useCallback(() => {
        // Trigger list refresh only after successful creation
        setRefreshKey(prev => prev + 1);
    }, []);

    useEffect(() => {
        const saved = localStorage.getItem('agentsActiveTab');
        if (saved === 'owned' || saved === 'interacted') {
            setActiveTab(saved);
        }
    }, []);

    const handleTabChange = useCallback(tabId => {
        setActiveTab(tabId);
        localStorage.setItem('agentsActiveTab', tabId);
    }, []);

    return (
        <MainLayout>
            <Sidebar />
            <ContentArea>
                <div className={styles.container}>
                    <div className={styles.content}>
                        <div className={styles.header}>
                            <h1>Agents</h1>
                            <p>Create and manage AI agents.</p>
                        </div>

                        <div className={styles.tabRow}>
                            <div className={styles.tabsWrapper}>
                                <UnderlineTabMenu
                                    tabs={[
                                        { id: 'owned', label: 'My Agents' },
                                        { id: 'interacted', label: 'Agents I Use' },
                                    ]}
                                    activeTab={activeTab}
                                    onTabChange={handleTabChange}
                                />
                            </div>
                            {activeTab === 'owned' && (
                                <PillButton
                                    onClick={handleCreateAgent}
                                    size="medium"
                                    title="Create your own agent"
                                >
                                    Create Agent
                                </PillButton>
                            )}
                        </div>

                        <AgentsList type={activeTab} refreshSignal={refreshKey} />
                    </div>
                </div>
            </ContentArea>

            <Modal
                isOpen={isCreateModalOpen}
                onClose={handleCloseCreateModal}
                title="Create Agent"
            >
                <CreateAgentForm onClose={handleCloseCreateModal} onCreated={handleAgentCreated} />
            </Modal>
        </MainLayout>
    );
};

export default memo(AgentsContainer);
